import React from 'react';

export const Logo = () => {
  return (
    <div className="d-flex justify-content-center mb-4 mt-3">
      <svg
        width="261"
        height="153"
        viewBox="0 0 261 153"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="logo"
      >
        <g clipPath="url(#clip0_66_870)">
          <path
            d="M0 118.6H7.61282L14.1174 129.413C15.2256 131.223 16.0036 133.437 16.0036 133.437H16.1518C16.1518 133.437 15.8554 131.075 15.8554 129.413V118.6H23.5794V144.99H15.8184L9.27678 133.659C8.31668 132.071 7.39364 129.672 7.39364 129.672H7.24545C7.24545 129.672 7.54182 131.997 7.54182 133.659V144.99H0V118.6Z"
            fill="#00287B"
          />
          <path
            d="M34.3287 118.6H42.9016L51.6227 144.99H43.8987L42.4941 140.118H34.696L33.3284 144.99H25.6045L34.3256 118.6H34.3287ZM40.8703 134.325L39.6509 130.042C39.2063 128.38 38.6908 125.319 38.6908 125.319H38.5426C38.5426 125.319 38.0239 128.383 37.5454 130.042L36.326 134.325H40.8703Z"
            fill="#00287B"
          />
          <path
            d="M65.8882 118.159C72.6892 118.159 76.014 121.702 76.014 121.702L72.9083 127.828C72.9083 127.828 70.2843 125.319 66.4779 125.319C61.8596 125.319 59.6399 128.309 59.6399 131.704C59.6399 135.099 61.9306 138.274 66.4779 138.274C70.6918 138.274 73.1306 135.21 73.1306 135.21L76.7518 141.188C76.7518 141.188 73.5381 144.99 66.9224 145.397L66.8113 146.319C68.3641 146.467 69.7688 147.277 69.7688 149.309C69.7688 152.115 67.2929 153 64.8541 153C63.3383 153 61.9337 152.667 61.9337 152.667V149.272C61.9337 149.272 62.7826 149.642 63.5976 149.642C64.4126 149.642 65.0022 149.346 65.0022 148.72C65.0022 148.095 64.2274 147.947 63.5235 147.947C63.0419 147.947 62.7116 148.021 62.7116 148.021L63.6717 145.289C56.2812 144.441 51.5146 139.051 51.5146 131.818C51.5146 124.03 57.3894 118.162 65.8882 118.162V118.159Z"
            fill="#00287B"
          />
          <path
            d="M85.3248 118.6H93.8977L102.619 144.99H94.8948L93.4902 140.118H85.6921L84.3245 144.99H76.6006L85.3217 118.6H85.3248ZM86.9146 110.926C89.4275 110.926 90.2024 112.955 91.6441 112.955C92.5301 112.955 93.0117 112.329 93.0117 111.037H97.4448C97.4448 114.987 95.7808 117.015 92.3449 117.015C89.832 117.015 89.0571 114.987 87.6154 114.987C86.7294 114.987 86.2478 115.616 86.2478 116.904H81.8147C81.8147 112.955 83.4787 110.926 86.9146 110.926ZM91.8664 134.325L90.647 130.042C90.2024 128.38 89.6869 125.319 89.6869 125.319H89.5387C89.5387 125.319 89.02 128.383 88.5415 130.042L87.3221 134.325H91.8664Z"
            fill="#00287B"
          />
          <path
            d="M116.699 118.159C125.198 118.159 130.89 123.953 130.89 131.63C130.89 139.307 125.201 145.434 116.699 145.434C108.197 145.434 102.508 139.492 102.508 131.63C102.508 123.768 108.197 118.159 116.699 118.159ZM116.699 138.385C120.172 138.385 122.685 135.654 122.685 131.63C122.685 127.606 120.172 125.208 116.699 125.208C113.226 125.208 110.713 127.791 110.713 131.63C110.713 135.469 113.226 138.385 116.699 138.385Z"
            fill="#00287B"
          />
          <path
            d="M143.6 136.058C143.6 136.058 146.669 138.789 150.216 138.789C151.398 138.789 152.395 138.419 152.395 137.312C152.395 135.91 150.657 135.614 147.999 134.507C144.637 133.141 140.942 131.075 140.942 126.351C140.942 121.295 145.193 118.159 151.105 118.159C156.649 118.159 159.863 120.965 159.863 120.965L157.313 127.128C157.313 127.128 154.43 124.804 151.179 124.804C149.96 124.804 148.925 125.1 148.925 126.244C148.925 127.535 150.478 127.831 152.621 128.679C156.205 130.082 160.382 132 160.382 137.094C160.382 141.706 156.872 145.434 150.441 145.434C144.011 145.434 140.353 141.854 140.353 141.854L143.603 136.061L143.6 136.058Z"
            fill="#00287B"
          />
          <path
            d="M169.319 118.6H177.892L186.613 144.99H178.889L177.484 140.118H169.686L168.319 144.99H160.595L169.316 118.6H169.319ZM175.86 134.325L174.641 130.042C174.197 128.38 173.681 125.319 173.681 125.319H173.533C173.533 125.319 173.014 128.383 172.536 130.042L171.316 134.325H175.86Z"
            fill="#00287B"
          />
          <path
            d="M187.761 118.6H195.745V134.618C195.745 137.127 197.149 138.382 199.44 138.382C201.73 138.382 203.135 137.127 203.135 134.618V118.6H211.118V135.099C211.118 141.151 206.426 145.434 199.366 145.434C192.305 145.434 187.761 141.151 187.761 135.099V118.6ZM199.585 111H206.605L202.098 116.904H196.408L199.585 111Z"
            fill="#00287B"
          />
          <path
            d="M215.4 118.6H226.116C234.281 118.6 239.492 123.435 239.492 131.738C239.492 140.041 234.281 144.987 226.116 144.987H215.4V118.597V118.6ZM225.6 138.493C229.184 138.493 231.29 136.206 231.29 131.738C231.29 127.27 229.073 125.094 225.6 125.094H223.383V138.49H225.6V138.493Z"
            fill="#00287B"
          />
          <path
            d="M242.857 118.6H260.484V124.949H250.84V128.565H258.564V134.84H250.84V138.641H261.003V144.99H242.86V118.6H242.857Z"
            fill="#00287B"
          />
          <path
            d="M64.1318 73.554H89.5387L114.915 21.8294L132.382 47.8767L142.52 25.1038L132.209 9.72765C128.131 3.64748 121.29 0 113.961 0C105.586 0 97.9356 4.76053 94.2465 12.2682L64.1287 73.554H64.1318Z"
            fill="url(#paint0_linear_66_870)"
          />
          <path
            d="M185.211 24.5272H159.805L134.428 76.2518L116.962 50.2045L106.823 72.9774L117.134 88.3535C121.213 94.4337 128.054 98.0812 135.382 98.0812C143.758 98.0812 151.408 93.3206 155.097 85.8129L185.215 24.5272H185.211Z"
            fill="url(#paint1_linear_66_870)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_66_870"
            x1="142.523"
            y1="36.777"
            x2="64.1317"
            y2="36.777"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00B028" />
            <stop offset="0.15" stopColor="#02A031" />
            <stop offset="0.43" stopColor="#09794B" />
            <stop offset="0.82" stopColor="#153A74" />
            <stop offset="1" stopColor="#1B1B89" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_66_870"
            x1="185.211"
            y1="61.3042"
            x2="106.823"
            y2="61.3042"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00B028" />
            <stop offset="0.15" stopColor="#02A031" />
            <stop offset="0.43" stopColor="#09794B" />
            <stop offset="0.82" stopColor="#153A74" />
            <stop offset="1" stopColor="#1B1B89" />
          </linearGradient>
          <clipPath id="clip0_66_870">
            <rect width="261" height="153" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
